import React, { useState } from "react";
import { Formik, Field, Form } from "formik";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import ImageUploading from "react-images-uploading";
import BannerHeader from "../images/register/BANDEAU_INSCRIPTION.png";
import IconTransporteur from "../images/register/INSCRIPTION_METTRE_CAMION_A_LOUER.png";
import IconBetonnier from "../images/register/INSCRIPTION_CHERCHE_CAMION_A_LOUER.png";
import IconWarning from "../images/register/PICTO_ATTENTION.svg";
import { Col, Container, Row } from "react-bootstrap";
import Autocomplete from "../components/Autocomplete";
import AddFile from "../images/add-file.png";
import AddPicture from "../images/add-picture.png";
import axios from "axios";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FilePond } from "react-filepond";
import "filepond/dist/filepond.min.css";
import MetaTags from "react-meta-tags";
import RegisterProgress from "../components/RegisterProgressBar";
import { useAuth } from "../ReactApp";

const SignupSchema = Yup.object().shape({
  firstName: Yup.string().required("Le prénom est requis."),
  lastName: Yup.string().required("Le nom est requis."),
  password: Yup.string()
    .required("Veuillez saisir un mot de passe.")
    .min(6, "Le mot de passe doit contenir au moins 6 caractères."),
  confirmPassword: Yup.string()
    .oneOf(
      [Yup.ref("password"), null],
      "Les mots de passe ne correspondent pas."
    )
    .required("Veuillez confirmer votre mot de passe."),
  mail: Yup.string().email("Email invalide").required("L'email est requis."),
  phone: Yup.string()
    .required("Le téléphone est requis.")
    .min(10, "Le téléphone doit comporter au moins 10 chiffres."),
});

function RegisterPage() {
  const { logIn } = useAuth();
  const navigate = useNavigate();
  const [type, setType] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [totalSteps, setTotalSteps] = useState(6);
  const [emailExist, setEmailExist] = useState("");
  const [nbVehicles, setNbVehicles] = useState(0);
  const [nbEmployees, setNbEmployees] = useState(0);
  const [offer, setOffer] = useState(null);
  const [subscription, setSubscription] = useState("user");
  const [showPassword, setShowPassword] = useState(false);

  function handleEditNbEmployees(event) {
    setNbEmployees(event.target.value);
  }

  function handleEditNbVehicle(event) {
    setNbVehicles(event.target.value);

    if (event.target.value <= 1) {
      setOffer("Pack 15 annonces");
      setSubscription("pack15");
    } else if (event.target.value > 1 && event.target.value <= 3) {
      setOffer("Pack 30 annonces");
      setSubscription("pack30");
    } else if (event.target.value > 3 && event.target.value <= 10) {
      setOffer("Abonnement Sérénité 12 mois");
      setSubscription("serenite12");
    } else if (event.target.value > 10) {
      setOffer("Abonnement Sérénité 24 mois");
      setSubscription("serenite24");
    } else if (event.target.value > 20) {
      setOffer("Pack 10 annonces");
      setSubscription("pack10");
    } else if (event.target.value > 30) {
      setOffer('Abonnement "régional"');
      setSubscription("betonierpro");
    } else if (event.target.value > 50) {
      setOffer('Abonnement "national"');
      setSubscription("betonierproplus");
    }
  }

  function handleSelectType(profile) {
    setType(profile);

    if (profile === "betonnier") {
      setTotalSteps(5);
    } else if (profile === "transporteur") {
      setTotalSteps(5);
    }
  }

  const [images, setImages] = useState([]);
  const maxNumber = 69;
  const onChange = (imageList, addUpdateIndex) => {
    setImages(imageList);
  };

  const [kbis, setKbis] = useState([]);
  const maxNumberKbis = 69;
  const onChangeKbis = (kbisList, addUpdateIndex) => {
    setKbis(kbisList);
  };

  const [pdfFiles, setPdfFiles] = useState([]);

  const onChangePdf = (fileItems) => {
    setPdfFiles(fileItems.map((fileItem) => fileItem.file));
  };

  const handleSubmit = (values) => {
    values.type = type;
    values.coordinates = document
      .getElementsByName("cities")[0]
      .getAttribute("coordinates");

    // Vérifiez si les cases ubiwan et audit sont cochées
    values.ubiwan = values.ubiwan ? 1 : 0;
    values.spartesAudit = values.spartesAudit ? 1 : 0;

    let data = new FormData();

    const images_to_send = [];
    images.map((image) => images_to_send.push(image.file ? image.file : image));

    const kbis_to_send = [];
    pdfFiles.map((kbis) => kbis_to_send.push(kbis.file ? kbis.file : kbis));

    Object.keys(values).map(function (key, index) {
      data.append(key, values[key]);
    });

    data.append("images", images_to_send[0]);
    data.append("kbis", kbis_to_send[0]);

    data.append("subscription", subscription);
    data.append("nbVehicles", nbVehicles);
    data.append("nbEmployees", nbEmployees);

    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    axios
      .post(process.env.REACT_APP_API_URL + "/v1/user/create", data, config)
      .then((response) => {
        if (response.status === 201) {
          const { access_token, user_id } = response.data.content;
          logIn({
            token: access_token,
            _id: user_id,
          });

          toast.success("Demande d'inscription envoyée avec succès !");
          navigate("/inscription-reussie");

          /* 
          BEGIN MDWCHRIS : pas besoin de déclencher une notification depuis le Front
          METTRE EN PLACE DEPUIS LE BACK
          if (values.ubiwan) {  
            // Envoi des données à Ubiwan si la case est cochée
            axios.post(process.env.REACT_APP_API_URL + "/v1/ubiwan/notify", values)
          }
  
          if (values.spartesAudit) {
            // Envoi des données à Spartes si la case est cochée
            axios.post(process.env.REACT_APP_API_URL + "/v1/spartes/notify", values)
          }
          END MDWCHRIS : pas besoin de déclencher une notification depuis le Front
          */
        } else {
          toast.warning("Erreur lors de votre inscription.");
        }
      })
      .catch((error) => {
        console.log("Erreur lors de l'inscription :", error);
        toast.error("Erreur lors de l'inscription. Veuillez réessayer.");
      });
  };

  return (
    <div className="register-form">
      <MetaTags>
        <title>Louez et Gérer vos Véhicules pour le Béton |</title>
        <meta
          name="description"
          content="Inscrivez-vous sur SoluSpots pour accéder à un large choix de véhicules pour le béton. Rejoignez notre plateforme pour louer, gérer et optimiser vos opérations de chantier dès aujourd'hui."
        />
      </MetaTags>

      <Link to="/">
        <img src={BannerHeader} alt="SoluSpots - La solution en béton" />
      </Link>

      <div className="register-form-content">
        <Formik
          initialValues={{
            firstName: "",
            lastName: "",
            companyName: "",
            mail: "",
            password: "",
            confirmPassword: "",
            images: {},
            phone: "",
            cities: {},
            siren: "",
            subscription: "",
            kbis: {},
            promocode: "",
            spartesAudit: false,
            ubiwan: false,
            conformiteCgv: false,
          }}
          validationSchema={SignupSchema}
          onSubmit={handleSubmit}
        >
          {({ values, isValid, touched, errors }) => (
            <Form>
              <div
                className="register-form-content-items"
                style={{ display: currentStep === 1 ? "block" : "none" }}
              >
                <Row>
                  <Col md={1} lg={3}></Col>
                  <Col md={10} lg={6}>
                    <div>
                      <h2>Inscription</h2>
                      <p>
                        Créez votre profil et accédez à notre communauté dédiée
                        au transport de béton.
                      </p>

                      <h3 className="register-form-content-text">
                        Parlez-nous de vous&nbsp;!
                      </h3>

                      <div className="register-form-content-profile">
                        <div
                          onClick={() => handleSelectType("transporteur")}
                          className={`register-form-content-block type-block ${
                            type === "transporteur" ? "selected" : ""
                          }`}
                        >
                          <img
                            className="type-block-image"
                            src={IconTransporteur}
                            alt=""
                          />
                          <p className="type-block-title">
                            <span className="green">Je suis transporteur</span>
                            <br />
                            Je mets mon véhicule
                            <br />
                            en location
                          </p>
                        </div>
                        <div
                          onClick={() => handleSelectType("betonnier")}
                          className={`register-form-content-block type-block ${
                            type === "betonnier" ? "selected" : ""
                          }`}
                        >
                          <img
                            className="type-block-image"
                            src={IconBetonnier}
                            alt=""
                          />
                          <p className="type-block-title">
                            <span className="green">Je suis bétonnier</span>
                            <br />
                            J'ai besoin de véhicule
                            <br />
                            pour le béton
                          </p>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={1} lg={3}></Col>
                </Row>

                <div className="register-footer">
                  <RegisterProgress
                    totalSteps={totalSteps}
                    currentStep={currentStep}
                  />
                  <div className="register-button">
                    <button
                      className="register-button-back"
                      type="button"
                      onClick={() => navigate("/")}
                    >
                      Retour
                    </button>
                    <button
                      className="register-button-next"
                      type="button"
                      onClick={() => {
                        setCurrentStep(currentStep + 1);
                      }}
                      disabled={type === ""}
                    >
                      Suivant
                    </button>
                  </div>
                </div>
              </div>

              <div
                className="register-form-content-items"
                style={{ display: currentStep === 2 ? "block" : "none" }}
              >
                <Row>
                  <Col md={1} lg={3}></Col>
                  <Col md={10} lg={6}>
                    <div>
                      <h2>Complétez votre profil</h2>
                      {type === "transporteur" && (
                        <div className="register-form-content-items-warningblock">
                          <img src={IconWarning} alt="" />
                          <p>
                            Pensez à vous munir du document suivant avant de
                            commencer votre inscription : Kbis.
                          </p>
                        </div>
                      )}
                      <Row className="gy-2">
                        <Col md={6}>
                          <Field name="lastName">
                            {({ field, form }) => (
                              <div className="register-form-field">
                                <label>Nom *</label>
                                <input type="text" {...field} />
                                {touched.lastName && errors.lastName && (
                                  <div className="error">{errors.lastName}</div>
                                )}
                              </div>
                            )}
                          </Field>
                        </Col>
                        <Col md={6}>
                          <Field name="firstName">
                            {({ field, form }) => (
                              <div className="register-form-field">
                                <label>Prénom *</label>
                                <input type="text" {...field} />
                                {touched.firstName && errors.firstName && (
                                  <div className="error">
                                    {errors.firstName}
                                  </div>
                                )}
                              </div>
                            )}
                          </Field>
                        </Col>
                        <Col md={6}>
                          <Field name="password">
                            {({ field, form }) => (
                              <>
                                <div className="register-form-field">
                                  <label>Mot de passe *</label>
                                  <div className="register-form-field-password">
                                    <input
                                      type={showPassword ? "text" : "password"}
                                      {...field}
                                    />
                                    <button
                                      className="button-hide-password"
                                      type="button"
                                      onClick={() =>
                                        setShowPassword(!showPassword)
                                      }
                                    >
                                      {showPassword ? (
                                        <FontAwesomeIcon icon={faEyeSlash} />
                                      ) : (
                                        <FontAwesomeIcon icon={faEye} />
                                      )}
                                    </button>
                                  </div>
                                  {touched.password && errors.password && (
                                    <div className="error">
                                      {errors.password}
                                    </div>
                                  )}
                                </div>
                              </>
                            )}
                          </Field>
                        </Col>
                        <Col md={6}>
                          <Field name="confirmPassword">
                            {({ field, form }) => (
                              <div className="register-form-field">
                                <label>Confirmation de mot de passe *</label>
                                <div className="register-form-field-password">
                                  <input
                                    type={showPassword ? "text" : "password"}
                                    {...field}
                                  />
                                  <button
                                    className="button-hide-password"
                                    type="button"
                                    onClick={() =>
                                      setShowPassword(!showPassword)
                                    }
                                  >
                                    {showPassword ? (
                                      <FontAwesomeIcon icon={faEyeSlash} />
                                    ) : (
                                      <FontAwesomeIcon icon={faEye} />
                                    )}
                                  </button>
                                </div>
                                {touched.confirmPassword &&
                                  errors.confirmPassword && (
                                    <div className="error">
                                      {errors.confirmPassword}
                                    </div>
                                  )}
                              </div>
                            )}
                          </Field>
                        </Col>

                        <Col md={6}>
                          <Field name="companyName">
                            {({ field, form }) => (
                              <div className="register-form-field">
                                <label>Nom de l'entreprise</label>
                                <input type="text" {...field} />
                                {touched.companyName && errors.companyName && (
                                  <div className="error">
                                    {errors.companyName}
                                  </div>
                                )}
                              </div>
                            )}
                          </Field>
                        </Col>
                        <Col md={6}></Col>

                        <Col md={6}>
                          <Field name="mail">
                            {({ field, form }) => (
                              <div className="register-form-field">
                                <label>Mail *</label>
                                <input type="email" {...field} />
                                {touched.mail && errors.mail && (
                                  <div className="error">{errors.mail}</div>
                                )}
                                {emailExist === true && (
                                  <div className="error">
                                    Un compte existe déjà avec cet e-mail.{" "}
                                    <a href="/connexion">Connectez-vous.</a>
                                  </div>
                                )}
                              </div>
                            )}
                          </Field>
                        </Col>
                        <Col md={6}>
                          <Field name="phone">
                            {({ field, form }) => (
                              <div className="register-form-field">
                                <label>Téléphone *</label>
                                <input type="text" {...field} />
                                {touched.phone && errors.phone && (
                                  <div className="error">{errors.phone}</div>
                                )}
                              </div>
                            )}
                          </Field>
                        </Col>
                        <Col>
                          <Field name="images">
                            {({ form, field }) => (
                              <div className="register-form-field">
                                <label htmlFor="images">
                                  Ajouter une photo de profil
                                </label>
                                <ImageUploading
                                  multiple
                                  value={images}
                                  onChange={onChange}
                                  maxNumber={maxNumber}
                                  dataURLKey="data_url"
                                  className="location-form-upload"
                                >
                                  {({
                                    imageList,
                                    onImageUpload,
                                    onImageRemoveAll,
                                    onImageUpdate,
                                    onImageRemove,
                                    isDragging,
                                    dragProps,
                                  }) => (
                                    // write your building UI
                                    <div className="register-form-field-image">
                                      {imageList.length > 0 ? (
                                        ""
                                      ) : (
                                        <>
                                          <button
                                            className="btnActionUpload"
                                            type="button"
                                            style={
                                              isDragging
                                                ? { color: "red" }
                                                : null
                                            }
                                            onClick={onImageUpload}
                                            {...dragProps}
                                          >
                                            <img
                                              src={AddPicture}
                                              alt=""
                                              width="50"
                                            />
                                          </button>
                                          <p>
                                            Cela peut-être le logo de votre
                                            entreprise.
                                          </p>
                                        </>
                                      )}
                                      {imageList.map((image, index) => (
                                        <div key={index} className="image-item">
                                          <img
                                            src={
                                              image.data_url
                                                ? image.data_url
                                                : process.env
                                                    .REACT_APP_API_URL + image
                                            }
                                            alt=""
                                          />
                                          <div className="image-item__btn-wrapper">
                                            <button
                                              className="btn btn-outline-secondary btn-sm"
                                              type="button"
                                              onClick={() =>
                                                onImageUpdate(index)
                                              }
                                            >
                                              Modifier
                                            </button>
                                            <button
                                              className="btn btn-outline-danger btn-sm"
                                              type="button"
                                              onClick={() =>
                                                onImageRemove(index)
                                              }
                                            >
                                              Supprimer
                                            </button>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </ImageUploading>
                              </div>
                            )}
                          </Field>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col md={1} lg={3}></Col>
                </Row>

                <div className="register-footer">
                  <RegisterProgress
                    totalSteps={totalSteps}
                    currentStep={currentStep}
                  />
                  <div className="register-button">
                    <button
                      className="register-button-back"
                      type="button"
                      onClick={() => {
                        setCurrentStep(currentStep - 1);
                      }}
                    >
                      Retour
                    </button>
                    <button
                      className="register-button-next"
                      type="button"
                      onClick={async (event) => {
                        try {
                          const response = await axios.post(
                            process.env.REACT_APP_API_URL +
                              "/v1/user/check-email",
                            {
                              email: values.mail,
                            }
                          );

                          if (response.data && response.data === "exist") {
                            setEmailExist(true);
                          } else {
                            setEmailExist(false);

                            if (
                              isValid &&
                              values.lastName !== "" &&
                              values.firstName !== "" &&
                              values.phone !== "" &&
                              values.mail !== ""
                            ) {
                              setCurrentStep(currentStep + 1);
                            }
                          }
                        } catch (error) {
                          // Gérer les erreurs de l'appel API
                          console.log(
                            process.env.REACT_APP_API_URL +
                              "/v1/user/check-email"
                          );
                          console.error(
                            "Erreur lors de l'appel API :",
                            error.response
                          );
                        }
                      }}
                      disabled={
                        values.lastName === "" ||
                        values.firstName === "" ||
                        values.phone === "" ||
                        values.mail === ""
                      }
                    >
                      Suivant
                    </button>
                  </div>
                </div>
              </div>

              <div
                className="register-form-content-items"
                style={{ display: currentStep === 3 ? "block" : "none" }}
              >
                <Row>
                  <Col md={1} lg={3}></Col>
                  <Col md={10} lg={6}>
                    <div>
                      <h2>Complétez votre profil</h2>

                      <Row className="gy-2">
                        <Col xs={12}>
                          <div className="register-form-field">
                            <label>Localisation *</label>
                            <span>Où est située votre entreprise&nbsp;?</span>
                            <Autocomplete
                              name="cities"
                              className={
                                errors.cities && touched.cities
                                  ? "is-invalid"
                                  : ""
                              }
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <Field name="siren">
                            {({ field, form }) => (
                              <div className="register-form-field">
                                <label>Siren *</label>
                                <input type="text" name="siren" {...field} />
                              </div>
                            )}
                          </Field>
                        </Col>
                        <Col md={6}></Col>

                        {type === "transporteur" && (
                          <>
                            <Col xs={12}>
                              <Field name="kbis">
                                {({ form, field }) => (
                                  <div className="register-form-field">
                                    <label htmlFor="kbis">
                                      Extrait de Kbis (Document de moins de 3
                                      mois)*
                                    </label>

                                    <FilePond
                                      files={pdfFiles}
                                      allowMultiple={true}
                                      onupdatefiles={onChangePdf}
                                      acceptedFileTypes={["application/pdf"]}
                                      labelIdle={`<img src="${AddFile}" alt="" width="50" />`}
                                      className="btnFileUpload"
                                    />
                                  </div>
                                )}
                              </Field>
                            </Col>
                          </>
                        )}

                        {type === "transporteur" && (
                          <>
                            <Col xs={6}>
                              <div className="register-form-field register-form-field-nbvehicles">
                                <label>
                                  Combien de véhicules avez-vous à louer&nbsp;?
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  name="nbVehicles"
                                  /* onChange={handleEditNbVehicle} MDWCHRIS : Plus besoin d'ajuster l'abonnement selon le nombre de vehicules */
                                />
                              </div>
                            </Col>
                          </>
                        )}

                        <Col xs={type === "transporteur" ? 6 : 12}>
                          <div className="register-form-field register-form-field-nbvehicles">
                            <label>Combien de salariés avez-vous&nbsp;?</label>
                            <input
                              type="number"
                              min="0"
                              name="nbEmployees"
                              onChange={handleEditNbEmployees}
                            />
                          </div>
                        </Col>

                        <Col xs={12}>
                          {type === "transporteur" && (
                            <>
                              <div className="register-form-field">
                                <label>
                                  Certifications chauffeurs et véhicules ({" "}
                                  <a href="/charte" target="_blank">
                                    <small>Lire la charte SoluSpots</small>
                                  </a>{" "}
                                  )
                                </label>
                              </div>
                              <div className="register-form-field-checkbox">
                                <Field
                                  id="checkbox-agree-vehicles"
                                  type="checkbox"
                                  name="conformitecheckVehicles"
                                />
                                <label htmlFor="checkbox-agree-vehicles">
                                  Nous attestons que nos véhicules sont en
                                  conformité avec la réglementation en vigueur
                                  et disposent des contrôles et certifications
                                  obligatoires à jour.
                                  <br />
                                </label>
                              </div>
                              <div className="register-form-field-checkbox">
                                <Field
                                  id="checkbox-agree-employees"
                                  type="checkbox"
                                  name="conformitecheckEmployees"
                                />
                                <label htmlFor="checkbox-agree-employees">
                                  Nous attestons que nos chauffeurs respectent
                                  la réglementation en vigueur et disposent de
                                  toutes les qualifications requises pour
                                  exercer leur activité.
                                  <br />
                                </label>
                              </div>
                            </>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col md={1} lg={3}></Col>
                </Row>

                <div className="register-footer">
                  <RegisterProgress
                    totalSteps={totalSteps}
                    currentStep={currentStep}
                  />
                  <div className="register-button">
                    <button
                      className="register-button-back"
                      type="button"
                      onClick={() => {
                        setCurrentStep(currentStep - 1);
                      }}
                    >
                      Retour
                    </button>
                    <button
                      className="register-button-next"
                      type="button"
                      onClick={() => {
                        setCurrentStep(currentStep + 1);
                      }}
                      disabled={
                        !isValid ||
                        values.cities === "" ||
                        values.siren === "" ||
                        (type === "transporteur" &&
                          (!values.conformitecheckVehicles ||
                            !values.conformitecheckEmployees))
                      }
                    >
                      Suivant
                    </button>
                  </div>
                </div>
              </div>

              <div
                className="register-form-content-items"
                style={{
                  display: currentStep === 4 ? "block" : "none",
                }}
              >
                <Container>
                  <Row>
                    <Col
                      md={{ span: 8, offset: 2 }}
                      lg={{ span: 6, offset: 3 }}
                    >
                      <h2>Dernière étape</h2>
                      <p>
                        Merci de compléter les informations suivantes pour
                        finaliser votre inscription.
                      </p>
                      <div className="register-form-content-text promo-banner-content">
                        <h4>Offre de lancement</h4>
                        <div className="promo-banner-content-text">
                          Frais d’inscription offerts :{" "}
                          <span className="text-decoration-line-through">
                            &nbsp;99,99 €&nbsp;
                          </span>
                        </div>
                      </div>

                      <Row className="mt-5" style={{ alignContent: "stretch" }}>
                        <Col sm={12} className="mb-4">
                          <Field name="promocode">
                            {({ field, form }) => (
                              <div className="register-form-field notcentered">
                                <label>Code promotionnel</label>
                                <input
                                  type="text"
                                  name="promocode"
                                  {...field}
                                />
                                <p>
                                  <small>
                                    Nous vous invitons à saisir un code
                                    promotionnel
                                  </small>
                                </p>
                              </div>
                            )}
                          </Field>
                        </Col>
                        <Col sm={12} className="mb-4">
                          <div className="register-form-field-checkbox">
                            <Field
                              id="checkbox-conformitecgv"
                              type="checkbox"
                              name="conformiteCgv"
                            />
                            <label htmlFor="checkbox-conformitecgv">
                              Je confirme avoir pris connaissance des{" "}
                              <a
                                href="/conditions-generales-de-vente"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Conditions Générales de Vente
                              </a>
                              .
                            </label>
                          </div>
                        </Col>
                        <Col sm={12} className="mb-4">
                          <div className="register-form-field-checkbox">
                            <Field
                              id="checkbox-ubiwan"
                              type="checkbox"
                              name="ubiwan"
                            />
                            <label htmlFor="checkbox-ubiwan">
                              Souhaitez-vous bénéficier de l’offre FLEET Ubiwan
                              pour la gestion de votre flotte de
                              véhicules&nbsp;?
                            </label>
                          </div>
                        </Col>
                        {nbEmployees > 20 ? (
                          <Col sm={12} className="mb-4">
                            <div className="register-form-field-checkbox">
                              <Field
                                id="checkbox-spartesAudit"
                                type="checkbox"
                                name="spartesAudit"
                              />
                              <label htmlFor="checkbox-spartesAudit">
                                Souhaitez-vous bénéficier d’un audit gratuit des
                                coûts sociaux et fiscaux avec Spartes&nbsp;?{" "}
                                <em>
                                  (déblocable uniquement via la souscription
                                  d'un de nos abonnements)
                                </em>
                              </label>
                            </div>
                          </Col>
                        ) : null}
                      </Row>
                    </Col>
                  </Row>
                </Container>
                <div className="register-footer">
                  <RegisterProgress
                    totalSteps={totalSteps}
                    currentStep={currentStep}
                  />
                  <div className="register-button">
                    <button
                      className="register-button-back"
                      type="button"
                      onClick={() => {
                        setCurrentStep(currentStep - 1);
                      }}
                      disabled={!isValid}
                    >
                      Retour
                    </button>
                    <button
                      className="register-button-next"
                      type="submit"
                      disabled={!values.conformiteCgv}
                    >
                      Valider mon inscription
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default RegisterPage;
